<template>
  <nt-form-weblead
    :id="id"
    :url-action="urlAction"
    :class="`nt-form-${theme}`"
    :success-message="successMessage"
    :error-messages="validationMessages"
    :send-file-by-email="sendFileByEmail"
    :file-sent-by-email-message="fileSentByEmailMessage"
    :url-back="urlBack"
    :button-back="buttonBack"
    :display-confirm="displayConfirm"
    :button-confirm="buttonConfirm"
    :pdf="pdf"
    :button-download="buttonDownload"
    :one-trust-url="oneTrustUrl"
    :link-to-open="linkToOpen"
    :link-target="linkTarget"
    :button-open-link-text="buttonOpenLinkText"
    :auto-redirect="autoRedirect"
    :enable-email-validation="enableEmailValidation"
    :tagging-fields="taggingFields"
    @on-change-form="validateForm($event)"
  >
    <!-- Hidden Fields -->
    <div>
      <nt-hidden id="oid" name="oid" :value="oid" />
      <nt-hidden id="retURL" name="retURL" :value="returnURL" />
      <nt-hidden
        id="recordType"
        name="recordType"
        value="0122E0000008opt"
        :validators="['required']"
      />
      <nt-hidden
        id="lead_source"
        name="lead_source"
        value="Niobium.Tech"
        :validators="['required']"
      />
      <nt-hidden
        id="LeadSubSource__c"
        name="LeadSubSource__c"
        :value="subSource"
        v-if="subSource"
      />
      <nt-hidden
        id="Type__c"
        name="Type__c"
        value="Business"
        :validators="['required']"
      />
      <nt-hidden
        id="Campaign_ID"
        name="Campaign_ID"
        :value="campaingId"
        v-if="campaingId"
      />
      <nt-hidden
        id="member_status"
        name="member_status"
        :value="memberStatus"
        v-if="campaingId"
      />
      <nt-hidden
        id="LeadGoalDescription__c"
        name="LeadGoalDescription__c"
        :value="leadDescription"
        v-if="leadDescription"
      />
      <nt-hidden
        id="Description__c"
        name="Description__c"
        :value="description"
        v-if="description"
      />
      <nt-hidden
        id="GTMSegmentation__c"
        name="GTMSegmentation__c"
        :value="gtmSegmentation"
        v-if="gtmSegmentation"
      />
      <slot name="hidden" />
    </div>
    <div class="nt-form__fields">
      <div class="nt-form__item" v-for="item in availableFormItems" :key="item.Name" :style="{order: item.Order}">
        <nt-select-weblead
          v-if="isDropDown(item.Name)"
          :name="item.Name"
          :id="item.Name"
          :label="item.Label"
          :placeholder="item.Placeholder"
          :theme="theme"
          :validators="requiredFilds(item.Name)"
          :multiselect="false"
          :data-source="setDataSource(item.Name)"
          :ref="item.Name === 'state' ? 'stateSelect' : '' "
          @changed="(text)=> {
            if ( item.Name === 'country') {
              updateSelectedCountry(text)
              clearStateInput()
            }
          }"
          :selected="formData[item.Name]"
          :helper-text="item.HelperText"
        />

        <nt-textarea
          v-else-if="isTextArea(item.Name)"
          :id="item.Name"
          :label="item.Label"
          :placeholder="item.Placeholder"
          :theme="theme"
          :validators="requiredFilds(item.Name)"
          :selected="formData[item.Name]"
          :helper-text="item.HelperText"
          :max-length="setMaxLength(item.Name)"
        >
        </nt-textarea>

        <nt-input
          v-else
          :id="item.Name"
          :label="item.Label"
          :placeholder="item.Placeholder"
          :name="item.Name"
          :theme="theme"
          :maxlength="setMaxLength(item.Name)"
          :validators="requiredFilds(item.Name)"
          :regex="item.Name == 'zip' ? '^[0-9]*$' : undefined"
          :selected="formData[item.Name]"
          :helper-text="item.HelperText"
        >
        </nt-input>
      </div>
    </div>

    <div class="nt-form__item">
      <nt-checklink-weblead
        id="EmailOptIn"
        name="EmailOptIn"
        :label="getLabel('Check link Custom')"
        :theme="theme"
        :validators="['required']"
        :custom-text="true"
        :data-source="{ Value: true }"
        :val="formData[name]"
      >
        <div class="links">
          I have read and accept the
          <a href="https://niobium.tech/en/contact/privacy-policy" target="_blank">
            <strong>
              Privacy Policy
            </strong>
          </a>
          and
          <a href="https://niobium.tech/Contact/Terms-of-use" target="_blank">
            <strong>
              Terms of Use
            </strong>
          </a>
        </div>
      </nt-checklink-weblead>
    </div>

    <div class="nt-form__item">
      <nt-checklink-weblead
        id="EmailOptIn__c"
        name="EmailOptIn__c"
        :label="getLabel('Check link Custom')"
        :theme="theme"
        :validators="['required']"
        :custom-text="true"
        :data-source="{ Value: true }"
        :val="formData[name]"
      >
        <div class="links">
          <div style="margin-bottom: 15px; text-decoration: none !important;">
            I agree to receive marketing communications about CBMM, its products, promotions and other related matters.
          </div>
          <br>
          CBMM respects your privacy and will only process your personal data for the purposes indicated above and / or set out in our           <a href="https://niobium.tech/en/contact/privacy-policy" target="_blank"><strong>Privacy Policy</strong></a>. Your data will be kept for as long as necessary for said purposes and will only be used and / or shared in the cases provided for in the           <a href="https://niobium.tech/en/contact/privacy-policy" target="_blank"><strong>Privacy Policy</strong></a> and / or the law. You can exercise your rights over your personal data at any time, under the terms of the           <a href="https://niobium.tech/en/contact/privacy-policy" target="_blank"><strong>Privacy Policy</strong></a> . You can also revoke your consent at any time by clicking <a href="https://privacyportal.onetrust.com/ui/#/preferences/login/01b31f72-d60e-4e09-a18d-0bf54c10e419" target="blank"><strong>here</strong></a>. For more information, you can contact us through the <a href="https://niobium.tech/en/contact/privacy-policy/data-subject-rights" target="_blank"><strong>Request Portal</strong></a>
        </div>
      </nt-checklink-weblead>
    </div>

    <div class="nt-form__item" style="text-align: center" v-if="useCaptcha">
      <nt-recaptcha
        ref="recaptcha"
        data-sitekey="6Len2twZAAAAAAr_bdvRUXhnkrzPptngFsgBawZ9"
        :chaptcha-settings="{
          keyname: 'cbmm_api_key_pair',
          fallback: 'true',
          orgId: oid,
          ts: '',
        }"
        :validators="['recaptcha']"
      >
      </nt-recaptcha>
    </div>

    <div class="nt-form__item" :class="`text--align-${submitAlignment}`">
      <nt-form-i-submit
        id="button-submit"
        :text="submitText"
        :theme="theme"
        :font-size="submitFontSize"
        :disabled="isSubmitDisabled"
      />
    </div>
  </nt-form-weblead>
</template>

<script>
import statesList from '../../../json/states.json'
import countryList from '../../../json/countries.json'

const countries = countryList.map((x) => ({ Text: x.name, Value: x.abbreviation }))
const getCountryName = abbr => {
  const match = countries.find(x => x.Value === abbr)
  return match ? match.Text : null
}

export default {
  name: 'nt-form-weblead-template',
  props: {
    id: String,
    subSource: String,
    institutional: { type: Boolean, default: false },
    campaingId: String,
    memberStatus: String,
    leadDescription: String,
    description: String,
    gtmSegmentation: String,
    theme: {
      type: String,
      default: 'small',
    },
    submitText: { type: String, default: 'Submit' },
    pdf: { type: String },
    sendFileByEmail: { type: Boolean },
    fileSentByEmailMessage: { type: String },
    config: Array,
    urlAction: { type: String, default: 'https://content.niobium.tech/l/903131/2021-02-26/49w5' },
    validationMessages: {
      type: Object,
      default: () => {
        return {
          required: 'Required field.',
          email: 'Invalid email.',
          recaptcha: 'Required field.',
        }
      },
    },
    useCaptcha: {
      type: Boolean,
      default: true,
    },
    urlBack: {
      type: String,
    },
    buttonBack: {
      type: String,
      default: 'Back'
    },
    successMessage: { type: String, default: 'Thank you!' },
    buttonDownload: { type: String, default: 'Click here to download' },
    displayConfirm: { type: Boolean, default: false },
    buttonConfirm: { type: String, default: 'Ok' },
    submitFontSize: { type: [String, Number], default: null },
    submitAlignment: { type: String, default: 'left' },
    oneTrustUrl: {
      type: String,
      default: '/api/sitecore/nt/onetrust'
    },
    linkToOpen: {
      type: String,
      default: ''
    },
    linkTarget: {
      type: String,
      default: '_blank'
    },
    buttonOpenLinkText: {
      type: String,
      default: ''
    },
    autoRedirect: {
      type: Boolean,
      default: false
    },
    enableEmailValidation: {
      type: Boolean
    },
    taggingFields: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      oid: '00D2E0000012e5n',
      selectedCountry: null,
      countries,
      isStateElementHidden: false,
      isStateInputHidden: false,
      formRefreshCount: 0,
      formTextAreaItems: {
        FormMessage__c: 'FormMessage__c',
        street: 'street'
      },
      formDropDownItems: {
        country: 'country',
        state: 'state',
      },
      formHiddenItems: {
        CBMMProductsOfInterest__c: 'CBMMProductsOfInterest__c',
        SubjectsOfInterest__c: 'SubjectsOfInterest__c'
      },
      inputMaxLenght: {
        zip: 9,
        CBMMNewProduct__c: 255,
        default: 100
      },
      formData: {},
      isSubmitDisabled: true
    }
  },
  watch: {
    selectedCountry(newValue) {
      const stateField = this.config.find(field => field.name === 'state')
      stateField.hide = !newValue || this.states.length === 0
      this.refreshForm()
    },
    formData: {
      handler() {
        this.validateForm(this.formData)
      },
      deep: true
    }
  },
  computed: {
    returnURL() {
      return `${window.location.href.replace(window.location.search, '')}?success=true`
    },
    errorURL() {
      return `${window.location.href.replace(window.location.search, '')}?success=false`
    },
    type() {
      return this.institutional ? 'Institutional' : 'Business'
    },
    states() {
      if (!this.selectedCountry) {
        return []
      }
      return statesList
        .filter(x => x.country === getCountryName(this.selectedCountry))
        .map(x => {
          return { Text: x.name, Value: x.value }
        })
    },
    availableFormItems() {
      this.formRefreshCount += 0
      return this.config.filter(item => item.Show && !item.hide).sort((a, b) => a.Order - b.Order)
    },
    handleStateField() {
      const hasDataStateField = this.states.length > 0
      if (hasDataStateField) {
        return ['required']
      }
      return []
    }
  },
  methods: {
    setDataSource(itemName) {
      if (itemName === 'country') {
        return this.countries
      }
      return this.states
    },
    requiredFilds(field) {
      if (field === 'email') {
        return ['required', 'email']
      }
      else if (field === 'CBMMNewProduct__c') {
        return []
      }
      else if (field === 'state') {
        return this.handleStateField
      }
      return ['required']
    },
    clearStateInput() {
      const hasDataStateField = this.states.length > 0
      const stateElement = this.$refs.stateSelect

      if (hasDataStateField && stateElement && stateElement.value !== null) {
        stateElement.value = null
      }
    },
    isDropDown(itemName) {
      return this.formDropDownItems[itemName] === itemName
    },
    isTextArea(itemName) {
      return this.formTextAreaItems[itemName] === itemName
    },
    setMaxLength(itemName) {
      return this.inputMaxLenght[itemName] || this.inputMaxLenght.default
    },
    getLabel(name) {
      const field = this.getFieldConfig(name)
      return field ? field.label : ''
    },
    getFieldConfig(name) {
      return this.config.find((x) => x.Name === name)
    },
    refreshForm() {
      this.formRefreshCount++
    },
    updateSelectedCountry(newValue) {
      this.selectedCountry = newValue
    },
    validateForm(formData) {
      this.isSubmitDisabled = Object.entries(formData).some(([key, value]) => {
        const isRequired = this.requiredFilds(key).includes('required')
        // eslint-disable-next-line no-extra-boolean-cast
        const isEmptyOrNull = !!!value
        return isRequired && isEmptyOrNull
      })

      const recaptchaValidated = !this.useCaptcha ||
        (window.grecaptcha && window.grecaptcha.getResponse && window.grecaptcha.getResponse())

      if (!recaptchaValidated) {
        this.isSubmitDisabled = true
      }
    }
  }
}
</script>
